// Canonical Diff Vader council reviewer set. Mirrors `SKILL_MAP` in
// rewind-corp/engineering-plugins/plugins/diff-vader/skills/dark-council/scripts/run-council.py.
// Order matches that file. Two parallel arrays because the surfaces speak
// different conventions:
//   - calibration UI groups by short slug ('correctness') — the form
//     `meta.reviewer_status` uses on the orchestrator wire.
//   - suppressions store the full skill id ('pr-reviewer-correctness') —
//     the form findings carry. See normalizeReviewer() in
//     packages/api/src/lib/calibration-rollup.ts.
// A unit test (test/council-reviewers.test.ts) asserts the two arrays stay
// 1:1 (IDs == 'pr-reviewer-' + slug at the same index).

export const COUNCIL_REVIEWER_SLUGS = [
  'correctness',
  'security-tenant-isolation',
  'test-adequacy',
  'blast-radius',
  'performance',
  'backup-correctness',
  'loop-design-system',
  'supply-chain',
  'supportability',
  'iac',
  'revertibility',
  'migration-safety',
  'github-actions',
  'generated-client',
  'cost',
] as const;

export const COUNCIL_REVIEWER_IDS = [
  'pr-reviewer-correctness',
  'pr-reviewer-security-tenant-isolation',
  'pr-reviewer-test-adequacy',
  'pr-reviewer-blast-radius',
  'pr-reviewer-performance',
  'pr-reviewer-backup-correctness',
  'pr-reviewer-loop-design-system',
  'pr-reviewer-supply-chain',
  'pr-reviewer-supportability',
  'pr-reviewer-iac',
  'pr-reviewer-revertibility',
  'pr-reviewer-migration-safety',
  'pr-reviewer-github-actions',
  'pr-reviewer-generated-client',
  'pr-reviewer-cost',
] as const;

export type CouncilReviewerSlug = typeof COUNCIL_REVIEWER_SLUGS[number];
export type CouncilReviewerId = typeof COUNCIL_REVIEWER_IDS[number];
